import CustomChart from './CustomChart';

export default CustomChart;
